import emailjs from '@emailjs/browser'

// EmailJS Configuration
// Get your keys from https://www.emailjs.com/
const EMAILJS_CONFIG = {
  serviceId: import.meta.env.VITE_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID',
  publicKey: import.meta.env.VITE_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY',
  templates: {
    contact: import.meta.env.VITE_EMAILJS_TEMPLATE_CONTACT || 'template_contact',
    newsletter: import.meta.env.VITE_EMAILJS_TEMPLATE_NEWSLETTER || 'template_newsletter',
    consultation: import.meta.env.VITE_EMAILJS_TEMPLATE_CONSULTATION || 'template_consultation',
    exitIntent: import.meta.env.VITE_EMAILJS_TEMPLATE_EXIT || 'template_exit'
  }
}

// Initialize EmailJS
emailjs.init(EMAILJS_CONFIG.publicKey)

/**
 * Send contact form email
 */
export const sendContactEmail = async (formData) => {
  try {
    const response = await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      EMAILJS_CONFIG.templates.contact,
      {
        from_name: formData.name,
        from_email: formData.email,
        message: formData.message,
        to_name: 'Contenta Team'
      }
    )
    return { success: true, data: response }
  } catch (error) {
    console.error('Contact email error:', error)
    return { success: false, error: error.text || 'Failed to send email' }
  }
}

/**
 * Send newsletter subscription email
 */
export const sendNewsletterEmail = async (email, name = '') => {
  try {
    const response = await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      EMAILJS_CONFIG.templates.newsletter,
      {
        subscriber_email: email,
        subscriber_name: name || 'New Subscriber',
        to_name: 'Contenta Team'
      }
    )
    return { success: true, data: response }
  } catch (error) {
    console.error('Newsletter email error:', error)
    return { success: false, error: error.text || 'Failed to subscribe' }
  }
}

/**
 * Send consultation request email
 */
export const sendConsultationEmail = async (formData) => {
  try {
    const response = await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      EMAILJS_CONFIG.templates.consultation,
      {
        client_name: formData.name,
        client_email: formData.email,
        client_phone: formData.phone || 'Not provided',
        service_type: formData.service || 'General',
        budget: formData.budget || 'Not specified',
        message: formData.message || 'No additional message',
        preferred_date: formData.date || 'Flexible',
        to_name: 'Contenta Team'
      }
    )
    return { success: true, data: response }
  } catch (error) {
    console.error('Consultation email error:', error)
    return { success: false, error: error.text || 'Failed to send request' }
  }
}

/**
 * Send exit intent offer email
 */
export const sendExitIntentEmail = async (email) => {
  try {
    const response = await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      EMAILJS_CONFIG.templates.exitIntent,
      {
        lead_email: email,
        offer_code: 'SAVE15',
        to_name: 'Contenta Team'
      }
    )
    return { success: true, data: response }
  } catch (error) {
    console.error('Exit intent email error:', error)
    return { success: false, error: error.text || 'Failed to capture lead' }
  }
}

export default {
  sendContactEmail,
  sendNewsletterEmail,
  sendConsultationEmail,
  sendExitIntentEmail
}
